/**
 * USC Cabinet API
 * Cabinet API
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {AssignedSSMDto} from './assignedSSMDto';

export enum SSMFormNames {
  '01' = 'Денежная',
  '02' = 'Натуральная',
  '03' = 'Льготы',
  '04' = 'Услуги',
}

export interface SocialSupportMeasure {
  id?: number;
  ssmCode?: string;
  name?: string;
  ssmForm?: keyof typeof SSMFormNames;
  regulatoryLevel?: string;
  regulatoryLevelName?: string;
  period?: string;
  assigned?: boolean;
  assignedSSM?: AssignedSSMDto;
}
